import "./styles.css";
import React from "react";

import ic_true from '../../assets/icon/true.png';
import ic_false from '../../assets/icon/false.png';

import { Modal, Button } from 'react-bootstrap';

function MetalDetectorTonForm(props) {
  const PARAM = props.workorder;
  // const PARAM_EQ = props.attachequipment;
  const [showModalChangeSequence, setShowModalChangeSequence] = React.useState(false);
  const [sequenceEdit, setSequenceEdit] = React.useState({});

  const PARAM_CALLBACK = (e) => props.callback(e);
  // console.log(PARAM);

  function getSequence(std, result_type, index) {
    let result = "-";
    let found_sequence = PARAM.sequence.filter(
      (sequence) =>
        sequence.standardid === std.standardid &&
        sequence.result === result_type &&
        sequence.index === index
    );
    // console.log(std, found_sequence);
    if (found_sequence.length > 0) {
      result = found_sequence[0].input;
      if (result === 0) {
        return <img src={ic_false} alt="ic_false" />;
      } else if (result === 1) {
        return <img src={ic_true} alt="ic_true" />;
      } else {
        return null;
      }
    }
  }

  function getStandartById(standardid) {
    let standard = PARAM.form[0].standards.filter((std) => std.standardid === standardid);
    if (standard.length > 0) {
      return standard[0].standardname;
    } else {
      return "";
    }
  }

  function openModalChangeSequence(std, result_type, index) {
    let found_index_sequence = PARAM.sequence.findIndex(
      (sequence) =>
        sequence.standardid === std.standardid &&
        sequence.result === result_type &&
        sequence.index === index
    );

    if (found_index_sequence >= 0) {
      setSequenceEdit(PARAM.sequence[found_index_sequence]);
      setShowModalChangeSequence(true);
    }
  }

  function onChangeSequence(result) {
    let sequence = {...sequenceEdit, input: result};
    setSequenceEdit(sequence);
  }

  function onSaveSequence() {
    // console.log(sequenceEdit);
    PARAM_CALLBACK(sequenceEdit);
    setShowModalChangeSequence(false);
  }

  return (

    <>
      <div className="content">
        <div className="content-page">
          <div className="head-content-page" style={{ margin: 0, height: 60 }}>
            Metal Detector 1 Ton
          </div>
          <div className="head-content-page-sub" style={{ margin: 0 }}>
            Test Metal Detecting
          </div>
          <table className={"table-form " + PARAM.formcode}>
            <tbody>
              <tr>
                <th rowSpan={2}>Test sequence</th>
                {PARAM.form[0].standards.map((standard, i) => (
                  <th key={i} colSpan={2}>
                    {standard.standardname}
                  </th>
                ))}
              </tr>
              <tr>
                {PARAM.form[0].standards.map((standard, i) => (
                  <>
                    <th key={i}>ASFOUND</th>
                    <th key={i + 1}>ASLEFT</th>
                  </>
                ))}
              </tr>
              {Array.from({ length: 10 }, (v, k) => k).map((v, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>
                  {PARAM.form[0].standards.map((standard, j) => (
                    <>
                      <td key={j} onClick={() => openModalChangeSequence(standard, "ASFOUND", (i + 1))}>{getSequence(standard, "ASFOUND", (i + 1))}</td>
                      <td key={j + 1} onClick={() => openModalChangeSequence(standard, "ASLEFT", (i + 1))}>{getSequence(standard, "ASLEFT", (i + 1))}</td>
                    </>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <Modal show={showModalChangeSequence} onHide={() => setShowModalChangeSequence(false)} style={{ zIndex: 1050 }}>
        <Modal.Header closeButton>
          <Modal.Title>Edit sequence test No. {sequenceEdit.index}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="detail-row">
            <div className="name">Standard : </div>
            <div className="value">{getStandartById(sequenceEdit.standardid)}</div>
          </div>
          <div className="detail-row">
            <div className="name">Result : </div>
            <div className="value">{sequenceEdit.result}</div>
          </div>
          <div className="detail-row">
            <div className="name">Select value : </div>
            <div className={"bt-img " + (sequenceEdit.input === 1 ? "active" : "")} onClick={() => onChangeSequence(1)}>
              <img src={ic_true} alt="ic_true" />
            </div>
            <div className={"bt-img " + (sequenceEdit.input === 0 ? "active" : "")} onClick={() => onChangeSequence(0)}>
              <img src={ic_false} alt="ic_false" />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div style={{ flexGrow: 1 }}></div>
          <Button variant="secondary" onClick={() => setShowModalChangeSequence(false)}>Close</Button>
          <Button variant="primary" onClick={() => onSaveSequence()}>SAVE</Button>
        </Modal.Footer>
      </Modal>
    </>

  );
}

export default MetalDetectorTonForm;
